import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row, Button, Spinner } from 'reactstrap';
import store1 from "../../assets/images/store1.jpg" 
import 'react-toastify/dist/ReactToastify.css'; 
import { ToastContainer, toast } from 'react-toastify';
import { getOEMList,baseURL } from '../../utils/oem';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import  ZendeskWidget  from "../../Components/CustomerSupport/ZendeskWidget";

const List = () => {
    const [companys, setcompanys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 8;
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
 
    const user = JSON.parse(sessionStorage.getItem("user")); 
    const role = user.role;
    useEffect(() => { 
        loadOemData(1);
    }, []); 
    const loadOemData = async (page) => {
        try { 
            const param={
                page: page,
                per_page: itemsPerPage, 
            }
            const response = await getOEMList(param);
            console.log(response); 
                
            if (response.status==200) {
                setcompanys(response.data.data);
                setTotalPages(response.data.total_pages);
                setCurrentPage(response.data.page); 
            }else {
                errornotify(response.data.message)  
            }
            } catch (error) {
                    
            errornotify(error.message) 
            } finally {
            setLoading(false);
        }
    };
    const  handlePageChange = (page) => {
        setCurrentPage(page); 
        loadOemData(page);
    };
    // useEffect(() => {
    //     window.zE && window.zE('webWidget', 'hide');
        
    //     // Show after 3 seconds
    //     setTimeout(() => {
    //       window.zE && window.zE('webWidget', 'show');
    //     }, 3000);
    //   }, []);
      

    if (loading) {
        return <div className="text-center mt-5"><Spinner /> Loading companys...</div>;
    }

    return (
        
        <div className="page-content">
             <ToastContainer />
             <ZendeskWidget />
             <BreadCrumb title="company List"  />
            <Row className="g-4">  
                <Col lg={12}> 
                     
                    
                    <Row  className="row">
                        {companys.length > 0 ? (
                            companys.map((company) => (
                                <Col xl={3} md={4} sm={6} key={company.id}>
                                    <Card>
                                        <CardBody>
                                            <img 
                                                src={company.storefront_image?`${baseURL}/file/oem/image/${company.storefront_image}` :store1} 
                                                alt={company.oem_brandname} 
                                                className="img-fluid d-block mx-auto mb-3"
                                                style={{ height: "200px",width:"100%" }}
                                            />
                                            <h5>{company.oem_companyname || "N/A"}</h5>
                                            <p><strong>location:</strong> {company.city} , {company.province}</p>

                                            <Row className="g-2 mt-3">
                                                <Col md={6}>
                                                    <Link 
                                                        className="btn btn-primary w-100"
                                                        to={`/company?companyId=${company.id}`}
                                                    >
                                                        <i className="ri-eye-line align-middle"></i> View
                                                    </Link>
                                                </Col>
                                                <Col md={6}>
                                                    <Link
                                                        className="btn btn-success w-100"  
                                                        to={`/company-setting?companyId=${company.id}`}
                                                    >
                                                        <i className="ri-pencil-line align-middle"></i> Edit
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col lg={12}>
                                <div className="text-center mt-5">
                                    <h4>No companys found.</h4>
                                </div>
                            </Col>
                        )}
                    </Row>

                    {/* Pagination */}
                    <Row className="mt-4 mb-4">
                        <Col sm={12} className="text-center">
                            <Button 
                                disabled={currentPage === 1} 
                                onClick={() =>{
                                    handlePageChange(currentPage - 1) 
                                } }
                            >
                                Previous
                            </Button>
                            <span className="mx-3">
                                Page {currentPage} of {totalPages}
                            </span>
                            <Button 
                                disabled={currentPage === totalPages} 
                                onClick={() => {
                                    handlePageChange(currentPage + 1) 
                                }}
                            >
                                Next
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default List;
